/**
 * Returns `from` as a same-origin path, or `fallback` when following it would leave the site.
 * Parsing with URL, as the browser does on navigation, defeats `//host`, `/\host` and
 * tab/newline tricks that a plain startsWith('/') check lets through. The normalized path is
 * also checked for a leading `//`, so dot-segment inputs such as `/.//host` cannot become a
 * protocol-relative URL.
 */
export function safeRedirectPath(from: string | null, origin: string, fallback = '/dashboard'): string {
  if (!from || !from.startsWith('/')) return fallback;
  try {
    const url = new URL(from, origin);
    const path = url.pathname + url.search + url.hash;
    // A normalized path like "//evil.com" (from "/.//evil.com") is protocol-relative: it would leave the site.
    return url.origin === origin && !path.startsWith('//') ? path : fallback;
  } catch {
    return fallback;
  }
}
